<template>
  <v-menu
    open-on-hover
    offset-y
    :close-on-content-click="false"
    max-width="520"
  >
    <template #activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
        class="ml-3 px-3 py-1 bra-5 d-inline-flex align-center"
        :style="badgeStyle"
      >
        <v-icon class="mr-1" size="18" color="#1447E6">$Boxes</v-icon>
        {{ total }} produto(s)
      </span>
    </template>

    <v-card class="pa-3" :style="cardStyle">
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="font-weight-medium text-subtitle-2">{{ titulo }}</div>
        <div class="text-gray-300 font-13">{{ produtos.length }} item(s)</div>
      </div>

      <v-divider />

      <div v-if="total">
        <div
          v-for="(p, i) in primeiros"
          :key="i"
          class="text-body-2 py-1"
        >
          <div class="d-flex flex-column bg-gray-200 pa-2 bra-7">
            <span
              style="background-color: #DBEAFE; color: #1447E6; width: fit-content;"
              class="px-2 py-n1 font-weight-medium bra-7 d-inline-flex font-12"
            >
              {{ p.idproduto }}
            </span>

            <span class="my-1">{{ p.descricao_produto }}</span>
            <span class="d-flex align-center font-11 text-gray-400">
              <div style="width: 8px; height: 8px; background-color: #00C950" class="bra-15 mr-1" />
              Grupo {{ produto_inicial.id_grupo }}
            </span>
          </div>
        </div>

        <div
          v-if="total > limite"
          class="text-caption mt-1 text-gray-500 font-13"
          style="opacity:.8;"
        >
          +{{ total - limite }} restante(s)…
        </div>
      </div>

      <div v-else class="text-body-2">
        Nenhum produto vinculado.
      </div>
    </v-card>
  </v-menu>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  produtos: { type: Array, default: () => [] },
  limite: { type: Number, default: 10 },
  titulo: { type: String, default: "Id Grupo | Cod. Produto | Descrição" },
  cursor: { type: String, default: "pointer" },
  maxHeight: { type: [Number, String], default: 260 },
  produto_inicial: { type: Object, required: true },
});

const total = computed(() => (props.produtos.length ? props.produtos.length : 0));
const primeiros = computed(() => (props.produtos || []).slice(0, props.limite));

const badgeStyle = computed(() =>
  `background-color: #ECF1FF; color: #1447E6; cursor: ${props.cursor};`
);

const cardStyle = computed(() => {
  const h = typeof props.maxHeight === "number" ? `${props.maxHeight}px` : props.maxHeight;
  return `max-height: ${h}; overflow: auto;`;
});
</script>
